import CityPageTemplate from "../city-template/CityPageTemplate";
import { kennebunkConfig } from "./data";

export default function KennebunkPage() {
  return <CityPageTemplate config={kennebunkConfig} />;
}